import { useQuery } from '@tanstack/react-query';
import { Option } from '../models';
import QUERY_KEYS from '../utils/QueryKeys';

export default function useBuyAllOption(packageId, schoolId) {
  return useQuery([QUERY_KEYS.BUY_ALL_OPTION, packageId], () => (
    Option
      .where({ packageId: packageId, buyAll: schoolId })
      .first()
      .then((res) => res.data)
  ), { enabled: !!(packageId && schoolId), placeholderData: null });
}
